module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-projects"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        Projects.\n      ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableData,
      "bordered": _vm.isBordered,
      "striped": _vm.isStriped,
      "narrowed": _vm.isNarrowed,
      "checkable": _vm.isCheckable,
      "loading": _vm.isLoading,
      "mobile-cards": _vm.hasMobileCards,
      "paginated": _vm.isPaginated,
      "per-page": 50,
      "pagination-simple": true,
      "default-sort": "user.first_name",
      "selected": _vm.selected,
      "checked-rows": _vm.checkedRows
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:checkedRows": function($event) {
        _vm.checkedRows = $event
      }
    }
  }, [
    [_c('b-table-column', {
      attrs: {
        "field": "id",
        "label": "ID",
        "width": "40",
        "sortable": "",
        "numeric": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.id) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "name",
        "label": "Name",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.name) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "description",
        "label": "Description",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.description) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "sort",
        "label": "Sort",
        "sortable": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.props.row.sort) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "status",
        "label": "Status",
        "sortable": ""
      }
    }, [_c('b-icon', {
      attrs: {
        "pack": "mdi",
        "icon": _vm.props.row.status ? 'done' : 'close'
      }
    })], 1), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "edit",
        "label": "Edit",
        "sortable": ""
      }
    }, [_c('b-icon', {
      attrs: {
        "pack": "mdi",
        "icon": _vm.props.row.status ? 'done' : 'close'
      }
    })], 1)], _vm._v(" "), _c('div', {
      staticClass: "has-text-centered",
      attrs: {
        "slot": "empty"
      },
      slot: "empty"
    }, [_c('span', {
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v("Table contains nothing.")])])
  ], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4f7e33e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_auth/Projects.vue
// module id = 835
// module chunks = 1